/* eslint-disable */
import { router } from '@/router'
import { User } from '@/models/user'
import { UserAPI } from '@/api/user.api'
import { BASE_PATH_APP } from '@/commons/config'
import JwtDecode from 'jwt-decode'
import GlobalStore from '@/store/modules/global'

import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { Sector } from '@/models/sector'

const AUTH = `${BASE_PATH_APP}-vaivem-auth`
const userApi = new UserAPI()

export interface ExpireJwtDecode {
  exp: number;
}

interface JwtDecodedToken {
  sub: number;
  name: string;
  username: string;
  email: string;
  roles: string[];
  sector: Sector;
}

const loadUserFromLocalStorage = () => {
  const { token = null, functionalities = [] } = JSON.parse(localStorage.getItem(AUTH)) || {}
  let user = null;
  if (token) {
    try {
      const decodedToken: JwtDecodedToken = JwtDecode(token);
      const { sub, name, username, email, roles, sector } = decodedToken;
      user = new User(sub, name, username, email, sector, functionalities, roles);
    } catch (error) {
      localStorage.removeItem(AUTH);
    }
  }
  if (GlobalStore) {
    GlobalStore.setUser(user);
  }
}

const login = (usernameOrEmail: string, password: string, returnUrl?: string): Observable<User> => {
  return userApi
    .signin(usernameOrEmail, password)
    .pipe(map(response => setSession(response, returnUrl)))
}

const logout = (type?: string, message?: string, isEstudante?: boolean): void => {
  localStorage.removeItem(AUTH);
  if (GlobalStore) {
    GlobalStore.setUser(null);
  }

  GlobalStore.setSnackBar({
    type: type || "success",
    message: message || "Saiu com sucesso!",
    show: true,
    timeout: 4000
  });

  if(isEstudante) router.push('/vaivem/confirmar-entrega/estudante/login')
  else router.push('/vaivem/confirmar-entrega/trabalhador/login')
};

const setSession = (authResult: any, returnUrl: any): User => {
  buildAuth(authResult)
  loadUserFromLocalStorage();

  const user = GlobalStore.user;

  if (isEstudante() && validateEstudante()) {
    router.push({ name: "estudante-confirma" })
  }
  else if (isDesempregado() && validateDesempregado()) {
    router.push(returnUrl || '/vaivem/confirmar-entrega/trabalhador/')
  }
  else {
    GlobalStore.setSnackBar({
      type: "error",
      message: "Você não possui acesso!",
      show: true,
      timeout: 4000
    });
  }

  return user;
}

const buildAuth = ({ token, functionalities }) => {
  localStorage.setItem(AUTH, JSON.stringify({ token, functionalities }))
}

const currentToken = () => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {}
  return token
}

const expireToken = (): number => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {};

  if (!token) return null;

  const { exp } = JwtDecode<ExpireJwtDecode>(token);
  return exp * 1000;
};

const isEstudante = () =>{
  const { meta, name } = router.currentRoute;
  return name === "login-estudante"
};

const isDesempregado = () =>{
  const { meta, name } = router.currentRoute;
  return name === "login-trabalhador"
}

const validateEstudante = ()=>{
  const user = GlobalStore.user;
  return user?.functionalities?.some(v => v === 'central_vaivem_estudante');
}

const validateDesempregado = () => {
  const user = GlobalStore.user;
  return user?.functionalities?.some(v => v === 'central_vaivem_desempregado');
}

const currentTokenDetran = () => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH+'-detran')) || {}
  return token
}

export default {
  login,
  logout,
  expireToken,
  loadUserFromLocalStorage,
  get currentVaiVemValue () {
    return GlobalStore.user
  },
  get token () {
    return currentToken()
  },
  get tokenDetran (){
    return currentTokenDetran()
  },
  validateEstudante,
  validateDesempregado
}
